/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import classes from "./features.module.css";

const Features = () => {
    return (
        <Box className={classes.features}>
            <Container maxWidth="xl" disableGutters className={classes.containerFet}>
                <Typography variant="h1" color="secondary" textAlign="center" className={classes.titleText}>
                    An experience beyond our features
                </Typography>
                <Grid container spacing={{ xs: 2, md: 3, xxl: 4 }} className={classes.featuresContent}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Maximize time and profits
                        </Typography>
                        <Typography color="V060" variant="body1">
                            Automate data entry and bank reconciliation to boost productivity and bring new revenue in
                            house.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Unleash your team potential
                        </Typography>
                        <Typography color="V060" variant="body1">
                            Empower your processes with advanced automation to deliver exceptional services to your
                            clients.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Supercharge financial operations
                        </Typography>
                        <Typography color="V060" variant="body1">
                            Accelerate financial processes and improve decision-making to drive businesses' growth.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Features;